import { type ThunkAction } from "redux-thunk";
import {
  beginSearchAction,
  type HSAActions,
  loadInitialDataAction,
  searchFailAction,
  searchSuccessAction,
} from "~/features/selectionAssistant/housing/redux/actions";
import { type RootState } from "~/app/store";
import { fetchHousingSearchResults } from "~/features/selectionAssistant/housing/api/search/searchHousingAssistant";
import { getHousingClusterGroups } from "~/features/selectionAssistant/housing/api/getHousingClusterGroups";
import { getHousingSAFilterConfig } from "~/features/selectionAssistant/housing/api/getHousingSAFilterConfig";
import { type HousingSearchForm } from "~/features/selectionAssistant/housing/types/housingSAFormTypes";
import { NumberSystem } from "~/features/selectionAssistant/housing/types/types";
import { selectFilterConfig } from "~/features/selectionAssistant/housing/redux/selectors";
import { SearchReason } from "~/features/selectionAssistant/housing/redux/types";

type ThunkResult<R> = ThunkAction<R, RootState, undefined, HSAActions>;

export function initialiseHSAPage(query: HousingSearchForm): ThunkResult<void> {
  return async (dispatch, getState) => {
    const [searchResults, clusterGroupsData, metricTabularViewConfig, imperialTabularViewConfig] = await Promise.all([
      fetchHousingSearchResults(null, null),
      getHousingClusterGroups(),
      getHousingSAFilterConfig(NumberSystem.Metric),
      getHousingSAFilterConfig(NumberSystem.Imperial),
    ]);

    dispatch(
      loadInitialDataAction(
        metricTabularViewConfig.tabularViewColumnConfig,
        imperialTabularViewConfig.tabularViewColumnConfig,
        clusterGroupsData,
        searchResults,
      ),
    );
  };
}

export function runHSASearch(query: HousingSearchForm, searchReason: SearchReason): ThunkResult<void> {
  return async (dispatch, getState) => {
    dispatch(beginSearchAction(searchReason));

    try {
      const state = getState();
      const filterConfigMap = selectFilterConfig(state);
      let pageSize = state.housingSA.searchResults.pageSize!;
      if (searchReason === SearchReason.SORTING) {
        pageSize = pageSize * (query.page + 1);
        query = { ...query, page: 0 };
      }
      const results = await fetchHousingSearchResults(query, filterConfigMap, pageSize);
      dispatch(searchSuccessAction(results, searchReason));
    } catch (error) {
      console.error(error);
      dispatch(searchFailAction());
    }
  };
}
